<template>
  <li ref="container" v-if="variantData" class="text-sm block">
    <!-- header -->
    <div class="flex items-center w-full">
      <div @click="showValues = !showValues" class="grow flex items-center">
        <span class="cursor-pointer">
          <span class="text-black pr-1 text-xs">
          <template v-if="variant.conf_groups_title">
            {{ variant.conf_groups_title[variant.conf_group_idx] }}:
          </template>
          <template v-else> {{ variant.group }} {{ variant.title }}: </template>
        </span>
          <template v-if="variantValues.length > 0">
            <template v-for="(value, valueIdx) in variantValues">
            <span
                v-if="value.match"
                class="font-light text-xs"
                :key="'match_' + valueIdx"
            >
            {{ displayTitle(value) }}
              </span>
                </template>
          </template>
          <template v-else>
            <span class="inline-block w-24 h-4 bg-gray-100 animate-pulse rounded"></span>
          </template>
          </span>
        <div class="flex justify-center items-center w-6">
          <info-modal
            :id="variantData.idx?.split('.').pop()"
            :value="infoModalValue"
            :additional-value="firstValue && firstValue['additional_value']"
          />
        </div>
      </div>
      <!-- switch button -->
      <div v-if="hasAltTitle">
        <div class="relative bg-gray-100 p-0.5 rounded-lg flex shadow-inner text-[10px] h-6 w-24">
          <!-- Sliding Background -->
          <div
              class="absolute top-0.5 bottom-0.5 bg-white rounded-md shadow-sm transition-all duration-300 ease-out transform"
              :style="{
                width: 'calc(50% - 2px)',
                left: isAltActive ? 'calc(50% + 1px)' : '2px'
              }"
          ></div>

          <button
              type="button"
              class="relative flex-1 flex cursor-pointer items-center justify-center px-1 transition-colors duration-200 z-10 font-light"
              :class="!isAltActive ? 'text-brand-main font-bold' : 'text-gray-500'"
              @click="isAltActive = false"
          >
            {{ $t(pageStr + (variantData.idx || '').replace(/\./g, '_') + '.off') }}
          </button>
          <button
              type="button"
              class="relative flex-1 flex cursor-pointer items-center justify-center px-1 transition-colors duration-200 z-10 font-light"
              :class="isAltActive ? 'text-brand-main font-bold' : 'text-gray-500'"
              @click="isAltActive = true"
          >
            {{ $t(pageStr + (variantData.idx || '').replace(/\./g, '_') + '.on') }}
          </button>
        </div>
      </div>
      <div v-if="!showValuesMaster" @click="showValues = !showValues"
           class="shrink-0 ml-2 w-6 cursor-pointer text-brand-main">

        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 transition-transform duration-300"
            :class="{ 'rotate-180': showValues }"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </div>

    </div>
    <!-- values -->
    <ul v-if="showValues" ref="scrollContainer" @scroll="onScroll" class="font-light flex mt-2 overflow-x-auto pr-10 no-scrollbar">
      <template v-if="variantValues.length > 0">
        <li
            v-for="(value, valueIdx) in variantValues"
            :key="valueIdx"
            :data-match="value.match"
            :data-key="value.idx"
            ref="scrollIntoViewList"
            class="text-center cursor-pointer m-1 pb-2 flex justify-center items-top"
            :class="{
            'border-brand-main border-b-2':
              value.match &&
              variantData.idx != 'size' &&
              variantData.idx && !variantData.idx.includes('stone_number') &&
              !(
                (
                typeof value.image === 'string' ||
                  typeof value.image === 'object') &&
                variantData.select_option == 'image'
              ),
          }"
            @click="
            $emit('patch', {
              action: variantData.idx,
              value: value.idx,
              certificated_diamond: value.certificated_diamond
            })
          "
        >
          <template v-if="variantData.select_option == 'image' && variantData.idx != 'size'">
            <div
                v-if="typeof value.image === 'string' && value.image != '' &&  variantData.idx.includes('color')"
                class="relative mx-auto w-16 h-16"
            >
              <img
                  :src="value.image"
                  class="w-12 rounded-full mx-3"
                  :title="displayTitle(value)"
                  :alt="displayTitle(value)"
                  :class="{
                'border-brand-main border-2': value.match,
              }"
              />
              <p class="text-xs text-center w-16 pt-1">
                {{ displayTitle(value) }}
              </p>
            </div>
            <div
                v-else-if="typeof value.image === 'string' && value.image != '' && variantData.idx.includes('metal')"
                class="relative mx-auto z-20 w-20"
            >
              <img
                  :src="value.image"
                  class="mx-auto w-12 h-12 overflow-hidden rounded-full"
                  :title="displayTitle(value)"
                  :alt="displayTitle(value)"
                  :class="{
                'border-brand-main border-2': value.match,
              }"
              />
            </div>
            <div
                v-else-if="typeof value.image === 'string' && value.image != ''"
                class="relative mx-auto z-20 w-20"
            >
              <img
                  :src="value.image"
                  class="w-14 rounded-full mx-3"
                  :title="displayTitle(value)"
                  :alt="displayTitle(value)"
                  :class="{
                'border-brand-main border-2': value.match,
                '': !value.match,
              }"
              />
              <p class="text-xs text-center w-20 pt-1">
                {{ displayTitle(value) }}
              </p>
            </div>

            <div
                v-else-if="
              typeof value.image === 'object' && value.image.filename != ''
            "
                class="relative mx-auto z-20 w-20"
                :class="{
              'w-20': variantData.idx.includes('side_stones_id') || (variantData.idx.includes('simple_stones') && !variantData.idx.includes('stone_type')) || variantData.idx.includes('color') || variantData.idx.includes('halo_stone') || variantData.idx.includes('hidden_halo_stone')
            }"
            >
              <div
                  v-if="typeof variantData.image_type != 'undefined' && variantData.image_type != ''"
                  class="mx-auto"
              >
                <div
                    class="mx-auto w-12 h-10 overflow-hidden rounded-full"
                    :class="{
                'border-brand-main border-2': value.match,
                '': !value.match,
              }"
                >
                  <div
                      :style="getCssForImageDetail(variantData.image_type, variantData.idx, value.idx)"
                  >
                    <item-image
                        :image-url="value.image.filename"
                        :image-layer-url="value.image.filename_layer"
                    />
                  </div>
                </div>
                <p v-if="variantData.idx.includes('color') || variantData.idx.includes('stone_size') || variantData.idx.includes('stone_setting')"
                   class="w-full text-xs text-center px-2 pt-2">
                  {{ displayTitle(value) }}
                </p>
              </div>
              <div
                  v-else-if="variantData.idx.includes('side_stones_id') || variantData.idx.includes('simple_stones') || variantData.idx.includes('color') || variantData.idx.includes('metal')"
                  class="mx-auto"
              >
                <div
                    class="mx-auto w-12 h-10 overflow-hidden rounded-full"
                    :class="{
                'border-brand-main border-2': value.match,
                '': !value.match,
              }"
                >
                  <div
                      :style="getCssForImageDetail('ring_side', variantData.idx, value.idx)"
                  >
                    <item-image
                        :image-url="value.image.filename"
                        :image-layer-url="value.image.filename_layer"
                    />
                  </div>
                </div>

                <p v-if="variantData.idx.includes('color')" class="w-full text-xs text-center px-2 pt-2">
                  {{ displayTitle(value) }}
                </p>
              </div>
              <div
                  v-else-if="variantData.idx.includes('halo_stone') && !variantData.idx.includes('hidden_halo_stone')"
                  class="mx-auto"
              >
                <div
                    class="mx-auto w-12 h-10 overflow-hidden rounded-full"
                    :class="{
                'border-brand-main border-2': value.match,
                '': !value.match,
              }"
                >
                  <div
                      :style="getCssForImageDetail('center_size_small', variantData.idx, value.idx)"
                  >
                    <item-image
                        :image-url="value.image.filename"
                        :image-layer-url="value.image.filename_layer"
                    />
                  </div>
                </div>
              </div>
              <div
                  v-else-if="variantData.idx.includes('hidden_halo_stone')"
                  class="mx-auto"
              >
                <div
                    class="mx-auto w-12 h-10 overflow-hidden rounded-full"
                    :class="{
                'border-brand-main border-2': value.match,
                '': !value.match,
              }"
                >
                  <div
                      :style="getCssForImageDetail('center_stone', variantData.idx, value.idx)"
                  >
                    <item-image
                        :image-url="value.image.filename"
                        :image-layer-url="value.image.filename_layer"
                    />
                  </div>
                </div>
              </div>
              <div
                  v-else-if="variantData.idx.includes('stone_size')"
                  class="mx-auto"
              >
                <div
                    class="mx-auto w-16 h-14 overflow-hidden rounded-full"
                    :class="{
                'border-brand-main border-2 shadow-lg scale-110': value.match,
                '': !value.match,
              }"
                >
                  <div
                      :style="getCssForImageDetail('center_size', variantData.idx, value.idx)"
                  >
                    <item-image
                        :image-url="value.image.filename"
                        :image-layer-url="value.image.filename_layer"
                    />
                  </div>
                </div>
                <p class="w-full text-xs text-center px-2 pt-2">
                  {{ displayTitle(value) }}
                </p>
              </div>
              <template v-else>
                <div class="w-14 mx-auto">
                <item-image
                    :image-url="value.image.filename"
                    :image-layer-url="value.image.filename_layer"
                    class="rounded-full"
                    :class="{
                  'mx-auto border-brand-main border overflow-hidden':
                    value.match,
                }"
                />
                </div>
                <p v-if="displayTitle(value)" class="w-full text-xs text-center pt-2">
                  {{ displayTitle(value) }}
                </p>
              </template>
              <p
                  class="text-xs text-center w-full pt-1 px-2 overflow-hidden"
              >
                <template v-if="variant.conf_group_idx !== ''">
                  {{ displayTitle(value) }}
                </template>
                <template>
                  {{ displayTitle(value) }}
                </template>
              </p>
            </div>
          </template>
          <div v-else-if="variantData.idx == 'size' || variantData.idx.includes('stone_number')"
               class="w-full text-xs text-center px-2 pb-3">
            <p class="ring-gray-300 ring-offset-2 ring-2 rounded-full w-8 h-8 mx-auto flex items-center justify-center"
               :class="{
                'border-brand-main border-2': value.match,
              }"
            >
              {{ displayTitle(value) }}
            </p>

          </div>
          <p v-else class="w-full text-xs text-center px-2"
          >
            {{ displayTitle(value) }}
          </p>
        </li>
      </template>
      <template v-else>
        <template v-if="variantData.select_option == 'image' && variantData.idx != 'size'">
          <li v-for="n in 5" :key="'skeleton_img' + n" class="m-1 pb-2 shrink-0 flex flex-col items-center w-20">
            <div
                :class="variantData.idx.includes('metal') ? 'w-12 h-12' : 'w-16 h-16'"
                class="bg-gray-100 rounded-full animate-pulse mx-auto"
            ></div>
            <div v-if="!variantData.idx.includes('metal')" class="h-6 flex items-center justify-center w-full">
              <div class="h-2 bg-gray-100 rounded animate-pulse w-10"></div>
            </div>
          </li>
        </template>
        <template v-else-if="variantData.idx == 'size' || variantData.idx.includes('stone_number')">
          <li v-for="n in 5" :key="'skeleton_size' + n" class="m-1 pb-5 shrink-0 w-12">
            <div class="w-8 h-8 bg-gray-100 rounded-full animate-pulse mx-auto"></div>
          </li>
        </template>
        <template v-else>
          <li v-for="n in 5" :key="'skeleton_txt' + n" class="m-1 pb-2 shrink-0 w-16">
            <div class="h-4 bg-gray-100 rounded animate-pulse mx-auto w-12"></div>
          </li>
        </template>
      </template>
    </ul>
    <sidebar-navigation
        v-if="showValues"
        :total="variantValues.length"
        v-model="currentIndex"
        :container="scrollContainer"
        class="mb-2 pt-0!"
    />
  </li>
</template>

<script setup lang="ts">
import ItemImage from "@/components/itemImage.vue";
import {computed, inject, onMounted, onUnmounted, ref, watch, nextTick} from "vue";
import InfoModal from "@/components/info/infoModal.vue";
import SidebarNavigation from "@/components/sidebar/sidebarNavigation.vue";

defineEmits(["patch"]);
const props = defineProps(["variant", "variantData", "showValues", "itemFacts"]);
const showValuesMaster = ref((props.showValues === true));
const showValues = ref((props.showValues === true));

const loadItemVariants = inject<any>("loadItemVariants");
const itemIdx = inject<any>("itemIdx");
const container = ref<HTMLElement | null>(null);
const isIntersecting = ref(false);

let observer: IntersectionObserver | null = null;
onMounted(() => {
  if (container.value && loadItemVariants && itemIdx) {
    observer = new IntersectionObserver((entries) => {
      isIntersecting.value = entries[0].isIntersecting;
      if (isIntersecting.value && props.variantData?.values?.length === 0 && props.variantData.idx) {
        loadItemVariants(itemIdx.value, props.variantData.idx);
      }
    }, {
      rootMargin: '400px 0px', // Start loading before it's actually visible
      threshold: 0.01
    });
    observer.observe(container.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

watch(() => props.variantData?.values, (newValues) => {
  if (newValues && newValues.length === 0 && isIntersecting.value && props.variantData.idx) {
    loadItemVariants(itemIdx.value, props.variantData.idx);
  }
});


const scrollIntoViewList = ref<HTMLElement[] | null>(null);
const scrollContainer = ref<HTMLElement | null>(null);

const scrollToElement = () => {
  if (scrollIntoViewList.value) {
    const currentIdx = props.variantData.values.filter((value: { match: boolean }) => value.match)[0]?.idx || ""

    for (let selected_idx in scrollIntoViewList.value) {
      if (
          scrollIntoViewList.value[selected_idx].getAttribute("data-key") === currentIdx.toString()
      ) {
        if (typeof scrollIntoViewList.value[selected_idx].parentNode !== 'undefined') {
          const left = scrollIntoViewList.value[selected_idx].offsetLeft - scrollIntoViewList.value[selected_idx]?.parentNode?.offsetLeft - scrollIntoViewList.value[selected_idx]?.parentNode?.clientWidth / 2
          scrollIntoViewList.value[selected_idx]?.parentNode?.scrollTo({
                left: left,
                behavior: "auto"
              }
          )
        }
        break
      }
    }
  }
}

const variantValues = computed(() => {
  if (!props.variantData || !props.variantData.values) return [];
  const finaleValues = [];

  const conf_group_idx = props.variant.conf_group_idx;

  const usedSettings: string[] = [];

  for (let idx = 0; idx < props.variantData.values.length; idx++) {
    const value = props.variantData.values[idx];

    if (conf_group_idx !== "") {
      if (conf_group_idx == "model") {
        if (
            props.variant.conf_groups.setting == value.conf_groups.setting &&
            props.variant.conf_groups.size == value.conf_groups.size
        ) {
          finaleValues.push(value);
        }
      } else if (conf_group_idx == "size") {
        if (
            props.variant.conf_groups.model == value.conf_groups.model &&
            props.variant.conf_groups.setting == value.conf_groups.setting
        ) {
          finaleValues.push(value);
        }
      } else if (conf_group_idx == "setting") {
        if (
            (props.variant.conf_groups.setting == value.conf_groups.setting &&
                value.match == true) ||
            (props.variant.conf_groups.setting !== value.conf_groups.setting &&
                !usedSettings.includes(value.conf_groups.setting))
        ) {
          usedSettings.push(value.conf_groups.setting);
          finaleValues.push(value);
        }
      }
    } else {
      if (
          !(
              props.variantData.idx &&
              (
                  props.variantData.idx.includes("side_stones_id")
                  // || props.variantData.idx.includes("simple_stones") // Unbekannt warum
              ) &&
              value.used_dependencies.length > 0
          )
      ) {
        finaleValues.push(value);
      }
    }
  }

  return finaleValues;
});

watch(variantValues, () => {
  nextTick(() => {
    scrollToElement();
  });
}, { deep: true });

const firstValue = computed(() => variantValues.value[0]);

const infoModalValue = computed(() => {
  if (!firstValue.value) return ""
  if (props.variantData.idx.includes("stone_quality") && firstValue.value.additional_value) return firstValue.value.additional_value.type
  return firstValue.value && firstValue.value['idx']
})

const manualIndex = ref(0);

const currentIndex = computed({
  get: () => manualIndex.value,
  set: (val) => {
    manualIndex.value = val;
    scrollToIndex(val);
  }
});

const scrollToIndex = (index: number) => {
  const el = scrollIntoViewList.value?.[index];
  if (el) {
    el.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
  }
};

const onScroll = () => {
  if (!scrollContainer.value) return;
  const container = scrollContainer.value;
  const containerCenter = container.scrollLeft + container.clientWidth / 2;

  let closestIndex = 0;
  let minDistance = Infinity;

  scrollIntoViewList.value?.forEach((el, index) => {
    if (!el) return;
    const elCenter = el.offsetLeft + el.clientWidth / 2;
    const distance = Math.abs(elCenter - containerCenter);
    if (distance < minDistance) {
      minDistance = distance;
      closestIndex = index;
    }
  });

  manualIndex.value = closestIndex;
};

watch(() => variantValues.value, (newValues) => {
  const idx = newValues.findIndex(v => v.match);
  if (idx >= 0) {
    manualIndex.value = idx;
  }
}, {immediate: true});

const isAltActive = ref(true);
const hasAltTitle = computed(() => variantValues.value.length > 0 && !!variantValues.value[0].alt_title);
const displayTitle = (value: any) => isAltActive.value && value.alt_title ? value.alt_title : value.title;

const pageStr = "components.itemV2.itemV2VariantsList."

/**
 * image size and viewport
 */

const getCssForImageDetail = (imageType: string, idx: string, idx_value: string) => {

  const stoneSize = (idx.includes("stone_size")) ? idx_value : props.itemFacts.biggest_stone;

  let width = 14
  let height = 14
  let translateY = -42
  let translateX = -12

  if (imageType == "ring_side") {
    // no change
  } else if (imageType == "center_stone") {
    width = 14 - 0.8 * stoneSize
    height = 14 - 0.8 * stoneSize
    translateY = -12
    translateX = -39 + 0.8 * stoneSize
  } else if (imageType == "center_size") {
    width = 10 - 1.4 * stoneSize
    height = 10 - 1.4 * stoneSize
    translateY = -38 + 3 * stoneSize
    translateX = -31 + 5 * stoneSize
  } else if (imageType == "center_size_small") {
    width = 8 - 1 * stoneSize
    height = 8 - 1 * stoneSize
    translateY = -40 + 3 * stoneSize
    translateX = -30 + 3 * stoneSize
  } else if (imageType == "ring") {
    width = 6
    height = 6
    translateY = -38
    translateX = -25
  } else if (imageType == 'earring_size') {
    width = 8 - 1 * stoneSize
    height = 8 - 1 * stoneSize
    translateY = -26 + 3 * stoneSize
    translateX = -8 + 3 * stoneSize
  } else if (imageType == 'tennis-bracelet-size') {
    width = 12 - 1 * stoneSize
    height = 12 - 1 * stoneSize
    translateY = -42 + 3 * stoneSize
    translateX = -8 + 3 * stoneSize
  } else if (imageType == 'tennis-necklace-size') {
    width = 16 - 1 * stoneSize
    height = 16 - 1 * stoneSize
    translateY = -53 + 3 * stoneSize
    translateX = -8 + 3 * stoneSize
  } else if (imageType.substring(0, 6) == "style=")
    return imageType.substring(6, imageType.length)

  return "width: " + width + "rem; height: " + height + "rem; transform: translateY(" + translateY + "%) translateX(" + translateX + "%);"
}


</script>

<style lang="css">
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>